import { c as _c } from "react/compiler-runtime";
import { Stack, Typography } from "@mui/material";
import React from "react";
import type { UseTRPCQueryResult } from "#/server/api/trpc";
import type { RouterOutputs } from "#/shared/api";
type SolutionComplexityLabelProps = {
  solution: UseTRPCQueryResult<RouterOutputs["project"]["getSolutionBySlug"]>;
};
export const SolutionComplexityLabel: React.FC<SolutionComplexityLabelProps> = t0 => {
  const $ = _c(9);
  const {
    solution
  } = t0;
  if (!solution.data) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      i: {
        whiteSpace: "nowrap",
        color: "text.secondary",
        fontSize: 11,
        fontWeight: "normal"
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== solution.data.spaceComplexity || $[2] !== solution.data.timeComplexity) {
    t2 = solution.data.timeComplexity && <Typography variant="body2" sx={{
      fontWeight: "bold"
    }}><i>TC:</i> {solution.data.timeComplexity}{solution.data.spaceComplexity && <i>  | </i>}</Typography>;
    $[1] = solution.data.spaceComplexity;
    $[2] = solution.data.timeComplexity;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== solution.data.spaceComplexity) {
    t3 = solution.data.spaceComplexity && <Typography variant="body2" sx={{
      fontWeight: "bold"
    }}><i>SC:</i> {solution.data.spaceComplexity}</Typography>;
    $[4] = solution.data.spaceComplexity;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <Stack direction="row" spacing={1} sx={t1}>{t2}{t3}</Stack>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};